import { ClassTeam } from '../pages/tourDetails/TournamentClasses/components/ClassesTag/ClassesTag';
import { Team, User } from '../types/tournament';
import { getDisplayName } from './userDisplayName';

let pairIdCounter = -1;

export const regenerateBoxLeaguePairs = (
  existingGroupTeams: ClassTeam[],
  newlySelectedSingleTeams: ClassTeam[],
  allAvailableTeams: ClassTeam[]
): Team[] => {
  const resolveUser = (userOrId: User | number): User | undefined => {
    if (typeof userOrId === 'object' && userOrId !== null) {
      return userOrId;
    }

    if (typeof userOrId === 'number') {
      const foundTeam = allAvailableTeams.find((t) =>
        t.users?.some((u: any) => (u.id || u) === userOrId)
      );
      if (foundTeam) {
        return foundTeam.users.find((u: any) => (u.id || u) === userOrId) as User;
      }
    }
    return undefined;
  };

  const rawUsersList: (User | number)[] = [
    ...existingGroupTeams.flatMap((team) => team.users),
    ...newlySelectedSingleTeams.flatMap((team) => team.users),
  ];

  const uniqueUsersMap = new Map<number, User>();

  rawUsersList.forEach((rawUser) => {
    const fullUser = resolveUser(rawUser);

    if (fullUser && fullUser.id && !uniqueUsersMap.has(fullUser.id)) {
      uniqueUsersMap.set(fullUser.id, fullUser);
    }
  });

  const distinctPlayers = Array.from(uniqueUsersMap.values());

  const newPairs: ClassTeam[] = [];

  for (let i = 0; i < distinctPlayers.length; i++) {
    for (let j = i + 1; j < distinctPlayers.length; j++) {
      const player1 = distinctPlayers[i];
      const player2 = distinctPlayers[j];

      if (!player1 || !player2) continue;

      const name = `${getDisplayName(player1)} / ${getDisplayName(player2)}`.trim();

      const newTeam: ClassTeam = {
        // Negative id for frontend - sends to backend once saved, creates proper id
        id: pairIdCounter--,
        name: name,
        users: [player1, player2],
        logo: null,
        seed: 0,
        captain: [],
      };

      newPairs.push(newTeam);
    }
  }

  return newPairs;
};
